var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGtmProcessSpinnerAcceleratedBlue3S = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "gtm-process-spinner-accelerated-blue-3s_svg__e9ic250nk5g81",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  viewBox: "-5 -2 94 94"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes e9ic250nk5g83_tr__tr{0%{transform:translate(41px,45px) rotate(0deg)}60%{transform:translate(41px,45px) rotate(90deg);animation-timing-function:cubic-bezier(.42,0,.58,1)}to{transform:translate(41px,45px) rotate(360deg)}}")), /*#__PURE__*/React.createElement("g", {
  id: "gtm-process-spinner-accelerated-blue-3s_svg__e9ic250nk5g82",
  style: {
    animation: "e9ic250nk5g83_tr__tr 2000ms linear infinite normal forwards"
  },
  transform: "translate(41 45)"
}, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "gtm-process-spinner-accelerated-blue-3s_svg__e9ic250nk5g83",
  transform: "translate(-41 -45)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-accelerated-blue-3s_svg__e9ic250nk5g84",
  r: 7.5,
  fill: "#479FFE",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1,
  transform: "translate(41.5 7.5)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-accelerated-blue-3s_svg__e9ic250nk5g85",
  r: 7.5,
  fill: "#479FFE",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1,
  transform: "translate(7.5 26.5)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-accelerated-blue-3s_svg__e9ic250nk5g86",
  r: 7.5,
  fill: "#479FFE",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1,
  transform: "translate(74.5 26.5)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-accelerated-blue-3s_svg__e9ic250nk5g87",
  r: 7.5,
  fill: "#479FFE",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1,
  transform: "translate(41.5 82.5)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-accelerated-blue-3s_svg__e9ic250nk5g88",
  r: 7.5,
  fill: "#479FFE",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1,
  transform: "translate(7.5 63.5)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "gtm-process-spinner-accelerated-blue-3s_svg__e9ic250nk5g89",
  r: 7.5,
  fill: "#479FFE",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: 1,
  transform: "translate(74.5 63.5)"
})))));
export { SvgGtmProcessSpinnerAcceleratedBlue3S as ReactComponent };
export default __webpack_public_path__ + "img/gtm-process-spinner-accelerated-blue-3s.ee267086ebe75fdde7072a225864f265.svg";